import { Component, OnInit, OnDestroy } from '@angular/core';
import { SkillService } from '../services/skill.service';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Department } from '../api-interfaces';
import { Location } from '@angular/common';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.css']
})

export class CreateCategoryComponent implements OnInit, OnDestroy {
  departments: Observable<Department[]>;
  categoryForm: FormGroup;
  private destroy: Subject<void> = new Subject<void>();
  category;

  constructor(
    public skillService: SkillService,
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.departments = this.skillService.getDepartment();
    this.categoryForm = this.formBuilder.group({
      category_name: new FormControl('', Validators.required),
      department_id: new FormControl('', [Validators.required])
    });
  }
  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  locationBack() {
    this.location.back();
  }

  // onCheckChange(event) {
  //   const formArray: FormArray = this.categoryForm.get('department_id') as FormArray;
  //   if (event.target.checked) {
  //     formArray.push(new FormControl(Number(event.target.value)));
  //   }
  // }
  validateFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      } else if (control instanceof FormGroup) {
        this.validateFormGroup(control);
      }
    });
  }

  newCategory(formData) {
    this.validateFormGroup(formData);
    if (formData.valid) {
      this.spinnerService.show();
      this.skillService.newCategory(formData.value).takeUntil(this.destroy)
        .subscribe(data => {
          if (data['status'] == true) {
            this.spinnerService.hide();
            this.flashService.show(data['message'], 'alert-success');
            this.router.navigateByUrl('categoryList')
          }
        },
          error => {
            this.spinnerService.hide();
            this.flashService.show(error['error']['message'], 'alert-danger');
          });
    }
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/create-category/create-category.component.ts